import React from "react";
import Modal from "../../containers/Modal";
import {Grid, Col} from "../../styles/Grid";

export default function SuccesModal({isOpen, close, theme}) {
   return (
      <Modal
         type="delete"
         isOpen={isOpen}
         close={() => {
            close();
         }}
         theme={theme}
      >
         <Grid>
            <Col large="12">
               <p className="title">¡FELICIDADES!</p>
            </Col>
            <Col large="12">
               <p className="text">Se guardo la información exitosamente, puedes editar la información en cualquier momento</p>
            </Col>
         </Grid>
      </Modal>
   );
}

/* deleteConfig={{
            deleteMessage: `¿Estás seguro de querer eliminarlo? ${id}`,
            cancelButton: "Cancelar",
            acceptButton: deleteAction,
         }} */
